<template>
    <div id="pageTable">
        <v-container
            class="d-flex align-center justify-center"
            style="height: 80vh; width: 80vw"
            v-if="rol != 'root' && rol != 'admin'"
        >
            <v-card
                class=""
                style="border-radius: 20px"
                max-width="500"
            >
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img
                            :src="'/static/icon/peligro.svg'"
                            class="imgModal"
                        />
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
        <v-container
            xl
            fluid
            v-else
        >
            <v-row>
                <v-col
                    cols="12"
                    lg="12"
                >
                    <data-table
                        ref="tablaCategorias"
                        :tableName="'Categorías del empleado'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        :perPage="[10, 25, 50, 100]"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :showAdvancedFilters="false"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd mr-3"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon
                                        dark
                                        class="mr-2"
                                        >add</v-icon
                                    >
                                    Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>
                        <tbody
                            slot="body"
                            slot-scope="{ data }"
                        >
                            <tr
                                :key="item.id"
                                v-for="item in data"
                            >
                                <td class="tblPrincipal">
                                    {{ item.nombre }}
                                </td>
                                <td class="tblPrincipal">
                                    {{ item.descripcion }}
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon
                                                        class="tamIconoBoton invertirColorBotones"
                                                        >edit</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="eliminar(item)"
                                                    small
                                                >
                                                    <v-icon
                                                        class="tamIconoBoton invertirColorBotones"
                                                        >delete</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            v-model="dialog"
            persistent
            max-width="750px"
            class="borde-card"
        >
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    class="botonModal"
                    id="btnModal"
                ></v-btn>
            </template>
            <v-card class="borde-card">
                <ValidationObserver
                    ref="form"
                    v-slot="{ invalid }"
                >
                    <v-card-title class="justify-center card_titulo">
                        <div class="headerModal">
                            <h2 class="titleModal">{{ tituloModal }}</h2>
                        </div>
                    </v-card-title>
                    <v-card-text class="card_texto">
                        <v-container
                            grid-list-md
                            id="contenedor"
                        >
                            <v-divider class="divider"></v-divider>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                >
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        name="Clave"
                                        rules="required"
                                    >
                                        <v-text-field
                                            outlined
                                            label="Clave"
                                            class="pa-0 ma-0"
                                            v-model="categoria.clave"
                                            :error-messages="errors"
                                            required
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                >
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        name="Empleado"
                                        rules="required"
                                    >
                                        <v-text-field
                                            outlined
                                            label="Nombre"
                                            class="pa-0 ma-0"
                                            v-model="categoria.nombre"
                                            :error-messages="errors"
                                            required
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                >
                                    <v-text-field
                                        outlined
                                        label="Descripción"
                                        class="pa-0 ma-0"
                                        v-model="categoria.descripcion"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end card_accion">
                        <v-btn
                            class="btnCerrar"
                            @click="cerrarModal()"
                            :disabled="isSaving"
                            elevation="0"
                        >
                            Cancelar
                        </v-btn>
                        <v-btn
                            class="btnGuardar"
                            @click="guardar()"
                            :disabled="invalid"
                            elevation="0"
                        >
                            Guardar
                        </v-btn>
                    </v-card-actions>
                </ValidationObserver>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Datatable from "@/components/datatable/Datatable";
    import categoriaEmpleadoApi from "../api/categoriaEmpleado";
    import Notify from "@/plugins/notify";
    export default {
        components: {
            "data-table": Datatable,
        },
        data() {
            return {
                datosLogin: null,
                rol: null,
                url: "catalogo/categoria_empleado/find",
                filters: {
                    activo: true,
                    paginate: true,
                    items_to_show: 10,
                },
                columns: [
                    {
                        label: "Nombre",
                        name: "nombre",
                        filterable: false,
                    },
                    {
                        label: "Descripción",
                        name: "descripcion",
                        filterable: false,
                    },
                    {
                        label: "Opciones",
                        name: "opciones",
                        filterable: false,
                        align: "center",
                    },
                ],
                categoria: {
                    clave: null,
                    nombre: null,
                    descripcion: null,
                },
                dialog: false,
                isSaving: false,
                tituloModal: "",
                accion: null,
            };
        },
        methods: {
            abrirModal(accion, item = null) {
                this.dialog = true;
                this.accion = accion;
                if (accion == "add") {
                    this.tituloModal = "Agregar categoría";
                } else {
                    this.tituloModal = "Actualizar categoría";
                    this.categoria.id = item.id;
                    this.categoria.clave = item.clave;
                    this.categoria.nombre = item.nombre;
                    this.categoria.descripcion = item.descripcion;
                }
            },
            cerrarModal() {
                this.resetValues();
                this.dialog = false;
            },
            guardar() {
                this.$refs.form.validate().then((success) => {
                    this.isSaving = true;
                    if (!success) {
                        this.isSaving = false;
                        return;
                    }

                    if (this.accion === "add") {
                        categoriaEmpleadoApi
                            .createCategoriaEmpleado(this.categoria)
                            .then((resp) => {
                                Notify.Success(
                                    "Operación exitosa",
                                    "La categoría se guardó satisfactoriamente"
                                );
                                this.$refs.tablaCategorias.getData();
                                this.isSaving = false;
                                this.cerrarModal();
                                this.$nextTick(() => {
                                    this.$refs.form.reset();
                                });
                            })
                            .catch((err) => {
                                this.isSaving = false;
                                if (typeof err.response.data.error === "string") {
                                    Notify.ErrorToast(err.response.data.error);
                                } else {
                                    let error = Object.values(err.response.data.error);
                                    let leyenda = ``;

                                    for (var i = 0; i < error.length; i++) {
                                        leyenda += `* ` + error[i] + `\n`;
                                    }
                                    Notify.ErrorToast(leyenda);
                                }
                            });
                    } else if (this.accion === "update") {
                        categoriaEmpleadoApi
                            .updateCategoriaEmpleado(this.categoria)
                            .then((resp) => {
                                Notify.Success(
                                    "Operación exitosa",
                                    "La categoría se actualizó correctamente"
                                );
                                this.$refs.tablaCategorias.getData();
                                this.isSaving = false;
                                this.cerrarModal();
                                this.$nextTick(() => {
                                    this.$refs.form.reset();
                                });
                            })
                            .catch((err) => {
                                this.isSaving = false;
                                if (typeof err.response.data.error === "string") {
                                    Notify.ErrorToast(err.response.data.error);
                                } else {
                                    let error = Object.values(err.response.data.error);
                                    let leyenda = ``;

                                    for (var i = 0; i < error.length; i++) {
                                        leyenda += `* ` + error[i] + `\n`;
                                    }
                                    Notify.ErrorToast(leyenda);
                                }
                            });
                    }
                });
            },
            eliminar(item) {
                Notify.Alert(
                    "ADVERTENCIA",
                    "¿Estás seguro que deseas eliminar la categoría?",
                    "Eliminar",
                    () => {
                        categoriaEmpleadoApi
                            .deleteCategoriaEmpleado(item.id)
                            .then((resp) => {
                                Notify.Success(
                                    "Operación exitosa",
                                    "La categoría ha sido eliminada satisfactoriamente"
                                );
                                this.$refs.tablaCategorias.getData();
                            })
                            .catch((err) => {
                                if (typeof err.response.data.error === "string") {
                                    Notify.ErrorToast(err.response.data.error);
                                } else {
                                    let error = Object.values(err.response.data.error);
                                    let leyenda = ``;

                                    for (var i = 0; i < error.length; i++) {
                                        leyenda += `* ` + error[i] + `\n`;
                                    }

                                    Notify.ErrorToast(leyenda);
                                }
                            });
                    }
                );
            },
            resetValues() {
                this.categoria = {
                    clave: null,
                    nombre: null,
                    descripcion: null,
                };
                this.tituloModal = "";
                this.$refs.form.reset();
            },
            setFilters() {},
            loadModalData() {},
        },
        created() {
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
        },
    };
</script>

<style scoped></style>
